import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/app.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: 'mini'
})
Vue.use(VueQuillEditor)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
